import classNames from 'classnames';
import React from 'react';
import { useDayPicker } from 'react-day-picker';
import Button from './Button';
import * as styles from './DayButton.module.scss';

interface DayButtonProps {
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  children?: React.ReactNode;
  activeModifiers?: {
    selected?: boolean;
    first?: boolean;
    last?: boolean;
    disabled?: boolean;
  };
}

const DayButton = React.forwardRef<HTMLButtonElement, DayButtonProps>(
  ({ disabled, onClick, children, activeModifiers = {} }, ref) => {
    const { mode } = useDayPicker();
    return (
      <div
        className={classNames(styles.dayWrapper, styles[mode], {
          [styles.selected]: activeModifiers.selected,
          [styles.first]: activeModifiers.first,
          [styles.last]: activeModifiers.last,
          [styles.disabled]: activeModifiers.disabled,
        })}
      >
        <Button
          className={styles.day}
          onClick={!disabled ? onClick : undefined}
          size="small"
          ref={ref}
        >
          {children}
        </Button>
      </div>
    );
  },
);

export default DayButton;
